var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.kadastr != null
    ? _c(
        "b-row",
        { staticClass: "doc_title" },
        [
          _c(
            "b-col",
            { attrs: { sm: "6" } },
            [
              _vm.kadastr != null
                ? _c(
                    "div",
                    { staticClass: "kadastr_field mb-4" },
                    [
                      _c(
                        "b-form-text",
                        {
                          attrs: {
                            id: "lbk_" + _vm.kadastr.type + _vm.kadastr.id,
                          },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(_vm.kadastr.name) +
                              "\n\t\t\t\t"
                          ),
                          _c("span", { staticClass: "color-danger-500" }, [
                            _vm._v(" * "),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("the-mask", {
                        staticClass: "form-control form-control-sm fs-xl",
                        attrs: {
                          mask: ["##########:##:###:####"],
                          placeholder: "##########:##:###:####",
                          name: "text",
                          type: "text",
                          masked: true,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.load_pai(_vm.kadastr)
                          },
                        },
                        model: {
                          value: _vm.kadastr.value,
                          callback: function ($$v) {
                            _vm.$set(_vm.kadastr, "value", $$v)
                          },
                          expression: "kadastr.value",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-overlay",
                { attrs: { show: _vm.loading_unit, rounded: "sm" } },
                [
                  _vm._l(_vm.addon_fields_draw, function (field) {
                    return _c(
                      "div",
                      { key: field.id, staticClass: "tab_pai_field mb-4" },
                      [
                        _c(
                          "b-form-text",
                          { attrs: { id: "help_" + field.type + field.id } },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(field.name) +
                                "\n\t\t\t\t\t"
                            ),
                            field.required == 1
                              ? _c(
                                  "span",
                                  { staticClass: "color-danger-500" },
                                  [_vm._v(" * ")]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        field.type === "string_input"
                          ? _c("b-form-input", {
                              staticClass: "fs-xl",
                              attrs: {
                                type: "text",
                                state: _vm.is_valid_field(field),
                                disabled: !_vm.is_valid_kadastr,
                                id: field.type + field.id,
                                size: "sm",
                              },
                              model: {
                                value: field.value,
                                callback: function ($$v) {
                                  _vm.$set(field, "value", $$v)
                                },
                                expression: "field.value",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        field.type === "yes_no"
                          ? _c("b-form-radio-group", {
                              attrs: {
                                id: "btn-radios-1",
                                "button-variant": "outline-primary",
                                options: [
                                  { text: "Так", value: "yes" },
                                  { text: "Ні", value: "no" },
                                ],
                                name: "radios-btn-default",
                                buttons: "",
                              },
                              model: {
                                value: field.value,
                                callback: function ($$v) {
                                  _vm.$set(field, "value", $$v)
                                },
                                expression: "field.value",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "1c_fields" }, [
                    _vm.pai_1c_active != null
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "descriptions border p-2 border-success",
                          },
                          _vm._l(_vm.pai_fields_active, function (info) {
                            return _vm.can_show_1c_field(info)
                              ? _c("div", { staticClass: "blck p-1" }, [
                                  _c("b", [_vm._v(_vm._s(info.field_name))]),
                                  _vm._v(
                                    "\n\t\t\t\t\t\t= " +
                                      _vm._s(info.field_val) +
                                      "\n\t\t\t\t\t"
                                  ),
                                ])
                              : _vm._e()
                          }),
                          0
                        )
                      : _vm._e(),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", { staticClass: "border-left", attrs: { sm: "6" } }, [
            _vm.pai_info.is_load && _vm.pai_info_data.length > 0
              ? _c(
                  "div",
                  { staticClass: "pai_info" },
                  [
                    _c("h3", { staticClass: "p-2" }, [
                      _vm._v("Дані 1С + Panorama"),
                    ]),
                    _vm._v(" "),
                    _vm._l(this.pai_info.data, function (pai, idx) {
                      return _c(
                        "div",
                        { staticClass: "bg-light rounded-top mb-2" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "accordion accordion-hover accordion-clean",
                              attrs: { id: "js_list_accordion" },
                            },
                            [
                              _c("div", { staticClass: "card" }, [
                                _c(
                                  "div",
                                  { staticClass: "card-header border" },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "card-title",
                                        class: {
                                          collapsed: !_vm.is_active_pai(idx),
                                          cant_select: !_vm.is_can_select(idx),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.setActivePai(idx)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fal fa-globe-americas width-2 fs-xl",
                                        }),
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(_vm.getOwner1c(pai)) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        ),
                                        _c("div", { staticClass: "ml-2" }, [
                                          _c("small", [
                                            _vm._v(_vm._s(pai.params.kadastr)),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.has_preview_info(pai)
                                  ? _c("div", { staticClass: "card-body" }, [
                                      _c(
                                        "div",
                                        { staticClass: "c_fields_preview" },
                                        [
                                          _vm.pai_1c_preview_active != null
                                            ? _c(
                                                "div",
                                                { staticClass: "descriptions" },
                                                [
                                                  _c(
                                                    "legend",
                                                    { staticClass: "small" },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\tПревю\n\t\t\t\t\t\t\t\t\t"
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    _vm.pai_fields_1c_active,
                                                    function (info) {
                                                      return _vm.can_show_1c_field(
                                                        info
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "blck p-1",
                                                            },
                                                            [
                                                              _c("b", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    info.field_name
                                                                  )
                                                                ),
                                                              ]),
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t= " +
                                                                  _vm._s(
                                                                    info.field_val
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t\t"
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    }
                                                  ),
                                                ],
                                                2
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                )
              : _c(
                  "div",
                  { staticClass: "color-danger-300 fs-xl text-center" },
                  [
                    _vm._v(
                      "\n\t\t\tУвага! Дана ЗД не перебуває в оренді підприємств ГК ІМК. Її придбання потребує отримання відмови від переважного права на придбання від поточного орендаря ЗД, а також передбачає подальші орендні взаємовідносини покупця із поточним орендарем ЗД – сторонньою компанією, яка не входить до складу ГК ІМК!\n\t\t"
                    ),
                  ]
                ),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }